













import { Component, Vue, Prop } from 'vue-property-decorator';
import { ELTABLE_FORMAT } from '@/utils/elTable_formatter';
import { TableColumn } from 'element-ui/types/table-column.d';

@Component<DateColumn>({
    name: 'DateColumn',
})
export default class DateColumn extends Vue {
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'right' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 180 }) private minWidth!: number | string;
    @Prop({ type: Boolean, default: false }) private fixed!: boolean;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;
    @Prop({ type: String, default: '' }) private prefix!: string;
    @Prop({ type: String, default: '' }) private postfix!: string;
    @Prop({ type: String, default: 'default'}) private format!: string;
    private formatter: (row: any, column: TableColumn) => string = (row: any, column: TableColumn) => {
        if (row[column.property]) {
            let func = ELTABLE_FORMAT.DateFormat;
            if (this.format === 'brief') func = ELTABLE_FORMAT.DateFormatBrief;
            else if (this.format === 'detail') func = ELTABLE_FORMAT.DateFormatDetail;
            return this.prefix + func(row, column) + this.postfix;
        } 
        return '계속';
    }
}
